export const initialVendorTickets = [
  {
    id: "a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11",
    subject: "Problema import catalogo",
    state: "in-lavorazione",
    createdAt: "2026-05-19T10:00:00",
    updatedAt: "2026-05-19T11:30:00",
    unreadCount: 2,
    description: "L'import del catalogo CSV fallisce con errore di formato.",
  },
  {
    id: "b1eebc99-9c0b-4ef8-bb6d-6bb9bd380a22",
    subject: "Richiesta chiarimenti pagamenti",
    state: "chiuso",
    createdAt: "2026-05-10T09:15:00",
    updatedAt: "2026-05-12T16:00:00",
    unreadCount: 0,
    description: "Vorrei capire come aggiornare il metodo di pagamento.",
  },
];

export const initialTicketMessages = {
  "a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11": [
    {
      id: "c2eebc99-9c0b-4ef8-bb6d-6bb9bd380a33",
      operator: true,
      message: "Buongiorno, stiamo verificando il file.",
      attachmentName: null,
      timestamp: "2026-05-19T11:00:00",
      editable: false,
    },
  ],
  "b1eebc99-9c0b-4ef8-bb6d-6bb9bd380a22": [],
};

export const ticketCreateMockResponse = {
  ticketId: "mock-ticket-created",
};
